import { Trash2 } from "lucide-react";
import { useState } from "react";
import ActionBar from "../../components/actionBar/ActionBar";
import AddAccountModal from "../../components/modals/accountModals/AddAccountModal";
import { useAccounts } from "../../hooks/useAccounts";
import strings from "../../i18n/i18nStrings";
import { TAccount } from "../../types/Accounts";
import { useNavigate } from "react-router-dom";

// const MAX_USERS = 5;

const AdminPage = () => {
  const { accounts } = useAccounts();
  const navigate = useNavigate();

  const [toBeDeletedAccount, setToBeDeletedAccount] = useState<TAccount>();
  const [isAddAccountModalOpen, setIsAddAccountModalOpen] = useState(false);
  const [isDeleteAccountModalOpen, setIsDeleteAccountModalOpen] =
    useState(false);

  const onCheckRemoveAccount = (account: TAccount) => {
    setToBeDeletedAccount(account);
    setIsDeleteAccountModalOpen(true);
  };

  return (
    <>
      <div className="p-0">
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-white">
                <th
                  className={`px-6 py-4 text-left text-xs font-bold uppercase tracking-wider text-gray-500`}
                  // onClick={() => sortUsers(true)}
                >
                  {strings.common.account}
                  {/* <span>
                    {sortingRules.byName.isAscending ? (
                      <ArrowDownNarrowWide className="inline w-4 h-4 ml-1 cursor-pointer" />
                    ) : (
                      <ArrowUpNarrowWide className="inline w-4 h-4 ml-1 cursor-pointer" />
                    )}
                  </span> */}
                </th>
                <th
                  className={`hidden md:table-cell px-6 py-4 text-left text-xs font-bold uppercase tracking-wider text-gray-500`}
                  // onClick={() => sortUsers(true)}
                >
                  {strings.admin.columns.users}
                  {/* {strings.common.email} */}
                  {/* <span>
                    {sortingRules.byEmail.isAscending ? (
                      <ArrowDownNarrowWide className="inline w-4 h-4 ml-1 cursor-pointer" />
                    ) : (
                      <ArrowUpNarrowWide className="inline w-4 h-4 ml-1 cursor-pointer" />
                    )}
                  </span> */}
                </th>
                <th
                  className={`hidden md:table-cell px-6 py-4 text-left text-xs font-bold uppercase tracking-wider text-gray-500`}
                  // onClick={() => sortUsers(true)}
                >
                  {strings.admin.columns.devices}
                  {/* {strings.common.email} */}
                  {/* <span>
                    {sortingRules.byEmail.isAscending ? (
                      <ArrowDownNarrowWide className="inline w-4 h-4 ml-1 cursor-pointer" />
                    ) : (
                      <ArrowUpNarrowWide className="inline w-4 h-4 ml-1 cursor-pointer" />
                    )}
                  </span> */}
                </th>
              </tr>
            </thead>
            <tbody>
              {accounts.map((account) => (
                <tr
                  key={account._id}
                  className="border-white hover:bg-gray-100 cursor-pointer"
                  onClick={() => {
                    // navigate(`/admin/${account._id}`);
                    navigate(`/admin/${account._id}/devices`);
                  }}
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-m text-gray-900">
                    {account.name}
                  </td>
                  <td className="hidden md:table-cell px-6 py-4 whitespace-nowrap text-sm font-m text-gray-900">
                    {account.userCount}
                  </td>
                  <td className="hidden md:table-cell px-6 py-4 whitespace-nowrap text-sm font-m text-gray-900">
                    {account.deviceCount}
                  </td>
                  {/* <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-semibold">
                    <div className="flex justify-end">
                      <button
                        className="text-red-600 hover:text-red-90 flex items-center gap-2"
                        onClick={() => onCheckRemoveAccount(account)}
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <ActionBar>
          {/* <p className="text-sm text-gray-500">
            {getAddUserAmountString() as string}
          </p> */}
          <button
            onClick={() => setIsAddAccountModalOpen(true)}
            // disabled={users.length >= MAX_USERS}
            className={`ml-auto px-4 py-3 border border-transparent rounded-md shadow-sm text-xs font-bold uppercase tracking-wider text-white ${"bg-blue-700 hover:bg-blue-800"}`}
          >
            {strings.admin.addAccount}
          </button>
        </ActionBar>
      </div>
      {isAddAccountModalOpen && (
        <AddAccountModal onClose={() => setIsAddAccountModalOpen(false)} />
      )}
      {/* 
      {isDeleteUsersModalOpen && (
        <DeleteUserModal
          onClose={() => setIsDeleteUsersModalOpen(false)}
          user={toBeDeletedUser}
        />
      )} */}
    </>
  );
};

export default AdminPage;
